<template>
  <section class="html-content g-24">
    <div v-html="data.html"></div>
  </section>
</template>

<script>

import Heading from "~/components/atoms/Heading.vue";

export default {
  components: {Heading},
  props: {
    data: Object
  },
}
</script>

<style scoped lang="scss">
.html-content {
  &:deep(a) {
    color: $blue;
  }

  &:deep(div) {
    display: block;
  }

  &:deep(p) {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &:deep(h2) {
    font-size: 18px;
    font-weight: 600;
    margin-top: 0;
  }

  &:deep(div) {
    flex: unset;
  }
}
</style>
